import React from 'react';

// Inline bar sparkline. Deliberately dependency-free -- it is a handful of
// <rect>s, and pulling a charting library in for this would cost far more than
// it returns. The final bar is emphasised because it is the most recent period.
function Sparkline({ values, width = 96, height = 30, className }) {
  const nums = (values || []).map((v) => (Number.isFinite(Number(v)) ? Number(v) : 0));
  if (!nums.length) {
    return <span className="text-muted">-</span>;
  }

  const max = Math.max(...nums, 0);
  const gap = 3;
  const barWidth = (width - gap * (nums.length - 1)) / nums.length;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {nums.map((value, i) => {
        // Zero still gets a 2px stub so an empty day reads as "nothing sold"
        // rather than as a gap in the series.
        const barHeight = max > 0 ? Math.max(2, (value / max) * height) : 2;
        return (
          <rect
            /* eslint-disable-next-line react/no-array-index-key */
            key={i}
            x={i * (barWidth + gap)}
            y={height - barHeight}
            width={barWidth}
            height={barHeight}
            rx="1.5"
            className={i === nums.length - 1 ? 'fill-gold-600' : 'fill-gold-300'}
          />
        );
      })}
    </svg>
  );
}

export default Sparkline;
